import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA  } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { DatePipe } from '@angular/common';
import { AuthInterceptor } from './interceptors/auth.interceptor';
import { FingerprintAIO } from '@awesome-cordova-plugins/fingerprint-aio/ngx';
import { SecureStorage } from '@awesome-cordova-plugins/secure-storage/ngx';
import { PrivacyPolicyComponent } from './pages/rules/privacy-policy.component';

@NgModule({
    declarations: [AppComponent, PrivacyPolicyComponent],
    imports: [
        BrowserModule,
        IonicModule.forRoot({
            scrollAssist: true,
            scrollPadding: false
          }),
        HttpClientModule,
        AppRoutingModule,
    ],
    providers: [
      { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
      DatePipe,
      { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
      FingerprintAIO,
      SecureStorage,
    ],
    bootstrap: [AppComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA ]
})
export class AppModule {}
